var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAirportIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 64,
    height: 64,
    rx: 32,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 64,
    height: 64,
    rx: 32,
    stroke: "#DCDEE1",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M41.7333 43.6L39.3333 32.6667L44 28C46 26 46.6667 23.3333 46 22C44.6667 21.3333 42 22 40 24L35.3333 28.6667L24.4 26.2667C23.7333 26.1333 23.2 26.4 22.9333 26.9333L22.5333 27.6C22.2667 28.2667 22.4 28.9333 22.9333 29.3333L30 34L27.3333 38H23.3333L22 39.3333L26 42L28.6667 46L30 44.6667V40.6667L34 38L38.6667 45.0667C39.0667 45.6 39.7333 45.7333 40.4 45.4667L41.0667 45.2C41.6 44.8 41.8667 44.2667 41.7333 43.6Z",
    stroke: "#E9353C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirportIcon);
export default __webpack_public_path__ + "static/media/airport-icon.fa3ba397785fd325a9c3809f16ddec24.svg";
export { ForwardRef as ReactComponent };